module.exports = __webpack_public_path__ + "static/media/greatsword-common.71938c59.png";